import { render, staticRenderFns } from "./user-case-batch-distribute.vue?vue&type=template&id=eff2b4ca&scoped=true"
import script from "./user-case-batch-distribute.vue?vue&type=script&lang=ts"
export * from "./user-case-batch-distribute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff2b4ca",
  null
  
)

export default component.exports